import {LauncherOverrides} from '../app-react/app-bootstrap/config-interfaces/launcher-overrides';
import {LauncherOverridesReader} from '../app-react/app-bootstrap/launcher-overrides-reader/launcher-overrides-reader';
import {StorageService} from '../app-react/services/storage/storage.service';
import {ConsoleLoggerService} from '../app-react/services/logger/console-logger.service';
import {HttpService} from '../app-react/services/http/http.service';
import {Check} from "@sparkware/app-utils";

const logger = new ConsoleLoggerService(true);
const httpService = new HttpService();
const storageService = new StorageService(logger);

function getLauncherOverrides(): LauncherOverrides {
    let launcherOverridesReader = new LauncherOverridesReader(storageService, logger);
    return launcherOverridesReader.getOverrides();
}

function tryGetHostnameFromURL(url) {
    try {
        return new URL(url).hostname;
    }
    catch (err) {
        return null;
    }
}

function processScriptsFromHTML(textHTML) {
    let elm = document.createElement('div');
    elm.id = 'wrapper';
    elm.innerHTML = textHTML;
    let scripts = elm.getElementsByTagName('script');
    // If we don't clone the results then "scripts"
    // will actually update live as we insert the new
    // tags, and we'll get caught in an endless loop
    let scriptsClone = [];
    for (let i = 0; i < scripts.length; i++) {
        scriptsClone.push(scripts[i]);
    }

    for (let i = 0; i < scriptsClone.length; i++) {
        let currentScript = scriptsClone[i];
        let s = document.createElement('script');
        // Copy all the attributes from the original script
        for (let j = 0; j < currentScript.attributes.length; j++) {
            let a = currentScript.attributes[j];
            s.setAttribute(a.name, a.value);
        }
        s.appendChild(document.createTextNode(currentScript.innerHTML));
        currentScript.parentNode.replaceChild(s, currentScript);
    }


    return elm;
}

// Add container for test-env banner and for new-bug banner for Mirage only
function addMirageBannersContainer() {
    let header = document.getElementsByClassName('header-buttons')[0];

    if (header) {
        let container = document.createElement("div");
        container.setAttribute('id', 'banners-container-for-mirage-only');
        header.appendChild(container); // Container holds test env banner and new bug button
        addMirageTestEnvBanner(container);
    } else {
        setTimeout(addMirageBannersContainer, 2000);
    }
}

//Add test environment warning text for Mirage only
function addMirageTestEnvBanner(container) {
    let testEnvBanner = document.createElement("div");
    testEnvBanner.setAttribute("id", "test-env-banner-for-mirage-only");
    let text = document.createTextNode("TEST ENVIRONMENT");

    testEnvBanner.appendChild(text);
    container.appendChild(testEnvBanner);

}

interface CreateB2CDataParams {
    cmsSource: string;
    country: string;
    languageIso3: string;
    languageIso2: string;
    publicationId: number;
}

async function createB2CData(params: CreateB2CDataParams): Promise<void> {
    /*
    let segments = {};
    let cmsApiOrigin = params.cmsSource || 'https://www.888casino.com';

    try {
        segments = await httpService.get(`${cmsApiOrigin}/api/segments`);
    } catch (err) {
        logger.error(`On startup failed to get the segments from ${cmsApiOrigin}`, err);
    }
    */


    window['webData'] = {
        domain: '888casino.com',
        country: params.country,
        publicationId: params.publicationId || 1841,
        segments: {"IsDemo":false,"IsDemoRSB":false,"IsReal":false,"IsRealRSB":false,"IsVIPNative":false,"IsHVNative":false,"IsVIPandHVNative":false,"IsVIPandHV":false,"IsStage":false,"IsMac":false,"IsChrome":true,"IsOpera":false,"IsEdge":false,"IsSafari":true,"IsiOSNative":false,"isAuthenticated":false,"IsFTD":false,"IsREG":true,"IsMobile":false,"IsIOS":false,"IsAndroid":false,"IsMirageTestAccount":false,"IsLangDE":false,"IsArab":false,"IsMobileBlock":false,"IsDeu":false,"IsUk":false,"IsCan":false,"IsSwe":false,"IsChe":false,"IsIrl":false,"IsNZ":false,"IsIndia":false,"IsJpn":false,"IsLangJP":false,"IsSupported888":false,"IsCstatus":true,"IsAnonymous":false,"IsNotFTD":true,"IsSupported88":false,"IsRegOffer":false,"IsMerkurEligible":false,"IsGermanGamesTargeted":false,"IsDeuOrAutOrChe":false,"IsDeuOrAutOrCheAndLangDe":false,"IsNotDeuNotAutNotChe":false,"IsNotDeu":true,"IsEuro":true,"IsUnsupported":false,"supportedAppstoreCountries":true,"IsNotSportEligibleCountry":true,"IsRestrictedCountry":false,"IsUsaLangEN":false,"IsUkOrIrl":false,"IsChatEligible":false,"IsNetEntOriented":false,"IsWinWinTime030218":false,"AuthenticatedUK":false,"AuthenticatedDE":false,"IsNorm":false,"IsNormOrHv":false,"IsHvOrVip":false,"IsHv":false,"IsVip":false,"IsHvOrVipNotUk":false,"IsUSD":false,"IsEUR":true,"IsGBP":false,"IsCAD":false,"IsFtdOffer":true,"IsRegOfferUK":false,"IsRegOfferDeu":false,"IsRegOfferCan":false,"IsRegOfferSwe":false,"IsCIP":false,"IsCIS":false,"IsNotLiveCasinoEligible":false,"IsArabLang":false,"IsArabic":false,"IsNotSwe":true,"IsMalteseLicense":false,"AdminIsArabOrVip":false,"Is77FreeSpinsEligible":false,"IsLatinAmericaES":false,"IsMalteseLicenseNoHolland":false,"NotUkNotMaltaLicense":true,"IsNotPromoDepositorOrNormOrHV":true,"IsNotPromoDepositorOrVIP":true,"IsNotDemoSupported":false,"isHybrid":false,"IsHybridEmbedded":false,"isHybridApp":false,"IsHybridLegacy":false,"IsLeadStatesUSA":false,"IsNewMember30Days":false,"IsNewMemberAbove30Days":true},
        languageSwitcher: {
            "languages": [{
                "title": "Deutsch",
                "url": "http://stage-de.888casino.com/"
            }, {"title": "Portuguese", "url": "http://stage-pt.888casino.com/"}, {
                "title": "Español",
                "url": "http://stage-es.888casino.com/"
            }, {
                "title": "简体中文",
                "url": "http://stage-cns.888casino.com/"
            }, {"title": "Suomi", "url": "http://stage-fi.888casino.com/"}, {
                "title": "日本語",
                "url": "http://stage-jp.888casino.com/"
            }, {"title": "Русский", "url": "http://ru.888casinofreespin.com/"}, {
                "title": "ภาษาไทย",
                "url": "http://stage-th.888casino.com/"
            }, {"title": "Français", "url": "http://stage-fr.888casino.com/"}],
            "countries": [{
                "title": "United Kingdom\t",
                "url": "https://www.888casino.com/default.htm",
                "sendFunnelParameters": true
            }, {"title": "United States", "url": "https://us.888casino.com"}, {
                "title": "Canada",
                "url": "http://stage-ca.888casino.com/"
            }, {
                "title": "España",
                "url": "https://www.888casino.es/",
                "onClickJs": "alert('España')",
                "sendFunnelParameters": true
            }, {"title": "Danmark", "url": "https://www.888casino.dk/"}, {
                "title": "România",
                "url": "https://www.888casino.ro/"
            }, {"title": "Italia", "url": "http://www.888casino.it/", "sendFunnelParameters": true}, {
                "title": "台灣 ",
                "url": "http://stage-tw.888casino.com/"
            }, {"title": "Phillipines", "url": "http://stage-ph.888casino.com/"}, {
                "title": "India",
                "url": "http://stage-in.888casino.com/"
            }],
            "languageSettings": {"title": "Choose your language:", "current": "English"},
            "countrySettings": {"title": "Or choose your country:"}
        },
        language: {iso2: params.languageIso2, iso3: params.languageIso3},
        sitemap: {
            "title": "888casino",
            "url": "/",
            "children": [{"title": "888casino", "url": "/error404.aspx"},
                {"title": "Mappa Del Sito", "url": "/mapa-del-sitio/"},
                {"title": "888Casino", "url": "/mobile/"},
                {"title": "888Casino", "url": "/mappa-del-sito/"},
                {"title": "888Casino", "url": "/disinstallazione/"},
                {
                    "title": "888Casino", "url": "/como-jugar/",
                    "children": [
                        {"title": "888Casino", "url": "/como-jugar/rtp/"}]
                },
                {
                    "title": "888Casino", "url": "/promozioni/",
                    "children": [
                        {"title": "888Casino", "url": "/promozioni/informativa-sui-bonus/"}]
                },
                {
                    "title": "888Casino", "url": "/come-ricaricare/",
                    "children": [
                        {"title": "888Casino", "url": "/come-ricaricare/ricarica/"},
                        {"title": "888Casino", "url": "/come-ricaricare/prelievi/"},
                        {"title": "888Casino", "url": "/come-ricaricare/conferma-identita/"}]
                },
                {
                    "title": "About",
                    "url": "/about/",
                    "children": [
                        {"title": "Awards", "url": "/about/awards/"}, {
                            "title": "Testimonials",
                            "url": "/about/testimonials/"
                        }, {
                            "title": "888 Casino Club",
                            "url": "/about/888-casino-club/"
                        }, {"title": "Who is Cassava Enterprises (Gibraltar) Limited", "url": "/about/casava/"}]
                }, {"title": "Online Baccarat", "url": "/baccarat/"},
                {
                    "title": "Online Baccarat",
                    "url": "/come-iniziare/",
                    "children": [{
                        "title": "rtp",
                        "url": "/come-iniziare/rtp/"
                    }]
                }, {
                    "title": "Banking",
                    "url": "/banking/",
                    "children": [{
                        "title": "Deposit",
                        "url": "/banking/deposit/",
                        "children": [{
                            "title": "How to Deposit",
                            "url": "/banking/deposit/how-to-deposit/"
                        }, {
                            "title": "Accepted Payment Methods",
                            "url": "/banking/deposit/payment-method/"
                        }, {
                            "title": "Secure Transactions",
                            "url": "/banking/deposit/secure/"
                        }, {
                            "title": "Deposit Processing Time Frames",
                            "url": "/banking/deposit/time-frames/"
                        }, {
                            "title": "Deposit Limits",
                            "url": "/banking/deposit/deposit-limit/"
                        }, {
                            "title": "Can’t See Your Deposit?",
                            "url": "/banking/deposit/cant-see-deposit/"
                        }, {
                            "title": "Upload your Documents Now",
                            "url": "/banking/deposit/verify/"
                        }, {"title": "Quick Deposit", "url": "/banking/deposit/quick-deposit/"}, {
                            "title": "Money Transfer",
                            "url": "/banking/deposit/money-transfer/"
                        }, {"title": "Online Casino Paypal", "url": "/banking/deposit/online-casino-paypal/"}]
                    }, {
                        "title": "Withdrawal",
                        "url": "/banking/withdrawal/",
                        "children": [{
                            "title": "How to Withdraw",
                            "url": "/banking/withdrawal/how-to-withdraw/"
                        }, {
                            "title": "Withdrawal Policy",
                            "url": "/banking/withdrawal/policy/"
                        }, {
                            "title": "Withdrawal Payment Time Frames",
                            "url": "/banking/withdrawal/time-frames/"
                        }, {
                            "title": "Reversing Your Withdrawal",
                            "url": "/banking/withdrawal/reversing/"
                        }, {"title": "Upload your Documents Now", "url": "/banking/withdrawal/verify/"}]
                    }]
                }, {
                    "title": "Online Blackjack",
                    "url": "/blackjack/",
                    "children": [{
                        "title": "American Blackjack",
                        "url": "/blackjack/american/"
                    }, {"title": "Classic Blackjack", "url": "/blackjack/classic/"}, {
                        "title": "High Limit Blackjack",
                        "url": "/blackjack/high-limit/"
                    }, {"title": "Multihand Blackjack", "url": "/blackjack/multihand/"}]
                },
                {
                    "title": "Casino Games",
                    "url": "/casino-games/",
                    "children": [{
                        "title": "Online Roulette",
                        "url": "/casino-games/online-roulette/"
                    }, {
                        "title": "Online Blackjack",
                        "url": "/casino-games/online-blackjack/"
                    }, {
                        "title": "Jackpots",
                        "url": "/casino-games/jackpots/"
                    }, {
                        "title": "All games",
                        "url": "/casino-games/all-games/"
                    }, {
                        "title": "Online Slots",
                        "url": "/casino-games/online-slots/",
                        "children": [{
                            "title": "Races",
                            "url": "/casino-games/online-slots/races"
                        }]
                    }]
                }, {
                    "title": "Casino Games",
                    "url": "/casino-spil/"
                }, {"title": "Casino Games", "url": "/giochi-da-casino/"}, {
                    "title": "Exclusive Mob",
                    "url": "/exclusive-mob/",
                    "children": [{
                        "title": "10bestcasinos",
                        "url": "/exclusive-mob/10bestcasinos.htm"
                    }, {
                        "title": "1500 88 Roulette",
                        "url": "/exclusive-mob/1500-88-roulette.htm"
                    }, {
                        "title": "1500-gamblinginsider",
                        "url": "/exclusive-mob/1500-gamblinginsider.htm"
                    }, {"title": "1500-30 Party", "url": "/exclusive-mob/1500-30-party.htm"}, {
                        "title": "888casino",
                        "url": "/exclusive-mob/1500-net-offer-canada.htm"
                    }, {
                        "title": "200 300 Casinobonus360",
                        "url": "/exclusive-mob/200-300-casinobonus360.htm"
                    }, {
                        "title": "200 400 Casinoorg",
                        "url": "/exclusive-mob/200-400-casinoorg.htm"
                    }, {
                        "title": "200-400 CasinosOnline",
                        "url": "/exclusive-mob/200-400-casinosonline.htm"
                    }, {
                        "title": "200-400 CasinoSource",
                        "url": "/exclusive-mob/200-400-casinosource.htm"
                    }, {
                        "title": "200-400 Gambling1",
                        "url": "/exclusive-mob/200-400-gambling1.htm"
                    }, {
                        "title": "200-400 OnlineCasinos",
                        "url": "/exclusive-mob/200-400-onlinecasinos.htm"
                    }, {
                        "title": "200-400 TopTenNetBoost",
                        "url": "/exclusive-mob/200-400-toptennetboost.htm"
                    }, {
                        "title": "200-400 VegasMaster",
                        "url": "/exclusive-mob/200-400-vegasmaster.htm"
                    }, {
                        "title": "2018 Countdown",
                        "url": "/exclusive-mob/2018-countdown.htm"
                    }, {
                        "title": "88 Freeplay Party",
                        "url": "/exclusive-mob/88-freeplay-party.htm"
                    }, {
                        "title": "88 Top Mobilec",
                        "url": "/exclusive-mob/88-top-mobilec.htm"
                    }, {"title": "888 Elite Lounge", "url": "/exclusive-mob/888-elite-lounge.htm"}, {
                        "title": "888 Slot",
                        "url": "/exclusive-mob/888-slot.htm"
                    }, {"title": "888-1500 Party", "url": "/exclusive-mob/888-1500-party.htm"}, {
                        "title": "888-200 Party",
                        "url": "/exclusive-mob/888-200-party.htm"
                    }, {"title": "88Freeplay", "url": "/exclusive-mob/88freeplay.htm"}, {
                        "title": "AS-Baccarat",
                        "url": "/exclusive-mob/as-baccarat.htm"
                    }, {"title": "Austria", "url": "/exclusive-mob/austria.htm"}, {
                        "title": "Baccarat",
                        "url": "/exclusive-mob/baccarat.htm"
                    }, {
                        "title": "Best UK Casino",
                        "url": "/exclusive-mob/best-uk-casino.htm"
                    }, {
                        "title": "Best Uk Casino Oce",
                        "url": "/exclusive-mob/best-uk-casino-oce.htm"
                    }, {"title": "bestselect", "url": "/exclusive-mob/bestselect/"}, {
                        "title": "Bestselect",
                        "url": "/exclusive-mob/bestselect.htm"
                    }, {"title": "Bingocouk", "url": "/exclusive-mob/bingocouk.htm"}, {
                        "title": "BJ 1500",
                        "url": "/exclusive-mob/BJ-1500.htm"
                    }, {"title": "BJ-verdiener", "url": "/exclusive-mob/BJ-verdiener.htm"}, {
                        "title": " Casino 1500",
                        "url": "/exclusive-mob/casino1500.htm"
                    }, {"title": "Casino 200 300", "url": "/exclusive-mob/casino-200-300.htm"}, {
                        "title": "Casino 88 1500",
                        "url": "/exclusive-mob/casino-88-1500.htm"
                    }, {
                        "title": "Casino 88 200 300",
                        "url": "/exclusive-mob/casino-88-200-300.htm"
                    }, {
                        "title": "casino-choice",
                        "url": "/exclusive-mob/casino-choice.htm"
                    }, {
                        "title": "Casinodaddy Special",
                        "url": "/exclusive-mob/casinodaddy-special.htm"
                    }, {"title": "CBclub", "url": "/exclusive-mob/CBclub.htm"}, {
                        "title": "cleopatra wheel",
                        "url": "/exclusive-mob/cleopatra-wheel.htm"
                    }, {"title": "cleopatra-1500-88", "url": "/exclusive-mob/cleopatra-1500-88.htm"}, {
                        "title": "Comp",
                        "url": "/exclusive-mob/comp.htm"
                    }, {"title": "Double 1500", "url": "/exclusive-mob/double-1500.htm"}, {
                        "title": "Double Offer",
                        "url": "/exclusive-mob/double-offer.htm"
                    }, {"title": "Double Triple", "url": "/exclusive-mob/double-triple.htm"}, {
                        "title": "Double Triple 200",
                        "url": "/exclusive-mob/double-triple-200.htm"
                    }, {
                        "title": "Edge 888free Wheel",
                        "url": "/exclusive-mob/edge-888free-wheel.htm"
                    }, {"title": "Edge 88Freeplay", "url": "/exclusive-mob/edge-88freeplay.htm"}, {
                        "title": "Elite Lounge",
                        "url": "/exclusive-mob/elite-lounge.htm"
                    }, {
                        "title": "Freeplay 100 140 New",
                        "url": "/exclusive-mob/freeplay-100-140-new.htm"
                    }, {
                        "title": "Freeplay 1500 New",
                        "url": "/exclusive-mob/freeplay-1500-new.htm"
                    }, {
                        "title": "Freeplay 200",
                        "url": "/exclusive-mob/freeplay-200.htm"
                    }, {
                        "title": "Freeplay Casinoenligne",
                        "url": "/exclusive-mob/freeplay-casinoenligne.htm"
                    }, {
                        "title": "Freeplay CasinoOnlineSpielen",
                        "url": "/exclusive-mob/freeplay-casinoonlinespielen.htm"
                    }, {
                        "title": "Freeplay Casinosfrancais",
                        "url": "/exclusive-mob/freeplay-casinosfrancais.htm"
                    }, {
                        "title": "Freeplay CasinoSpielen",
                        "url": "/exclusive-mob/freeplay-casinospielen.htm"
                    }, {"title": "Freeplay New", "url": "/exclusive-mob/freeplay-new.htm"}, {
                        "title": "Freeplay New",
                        "url": "/exclusive-mob/freeplay-new-intend.htm"
                    }, {
                        "title": "Freeplay OnlineCasinosSchweiz",
                        "url": "/exclusive-mob/freeplay-onlinecasinosschweiz.htm"
                    }, {
                        "title": "Freeplay Onlinecasinosuisse",
                        "url": "/exclusive-mob/freeplay-onlinecasinosuisse.htm"
                    }, {
                        "title": "Freeplay Parierenligne",
                        "url": "/exclusive-mob/freeplay-parierenligne.htm"
                    }, {
                        "title": "Freeplay Parierensuisse",
                        "url": "/exclusive-mob/freeplay-parierensuisse.htm"
                    }, {
                        "title": "Freeplay SwissCasino",
                        "url": "/exclusive-mob/freeplay-swisscasino.htm"
                    }, {
                        "title": "Freeplay Swisscasinoonline",
                        "url": "/exclusive-mob/freeplay-swisscasinoonline.htm"
                    }, {
                        "title": "Freeplay Topcasinoonline",
                        "url": "/exclusive-mob/freeplay-topcasinoonline.htm"
                    }, {
                        "title": "Gambling 1500",
                        "url": "/exclusive-mob/gambling1500.htm"
                    }, {
                        "title": "Gambling Sites Casino 1500",
                        "url": "/exclusive-mob/gamblingsitescasino1500.htm"
                    }, {
                        "title": "genie-1500-88",
                        "url": "/exclusive-mob/genie-1500-88.htm"
                    }, {
                        "title": "genie-1500-88-top-ten",
                        "url": "/exclusive-mob/genie-1500-88-top-ten.htm"
                    }, {
                        "title": "Irish 1500 888 wheel",
                        "url": "/exclusive-mob/Irish-1500-888-wheel.htm"
                    }, {"title": "irish-1500-88", "url": "/exclusive-mob/irish-1500-88.htm"}, {
                        "title": "LIVE BJ 1500",
                        "url": "/exclusive-mob/LIVE-BJ-1500.htm"
                    }, {
                        "title": "Live Roulette",
                        "url": "/exclusive-mob/Live-Roulette.htm"
                    }, {
                        "title": "Livefreeplay wheel",
                        "url": "/exclusive-mob/Livefreeplay-wheel.htm"
                    }, {
                        "title": "Livefreeplay wheel",
                        "url": "/exclusive-mob/Livefreeplay-wheel-intend.htm"
                    }, {"title": "Liveuk", "url": "/exclusive-mob/Liveuk.htm"}, {
                        "title": "Max 200-300",
                        "url": "/exclusive-mob/max-200-300.htm"
                    }, {"title": "Merkur 30", "url": "/exclusive-mob/merkur-30.htm"}, {
                        "title": "Merry Christmas",
                        "url": "/exclusive-mob/merry-christmas.htm"
                    }, {"title": "MG 1500 888 wheel", "url": "/exclusive-mob/MG-1500-888-wheel.htm"}, {
                        "title": "MGC",
                        "url": "/exclusive-mob/mgc.htm"
                    }, {"title": "MGC New", "url": "/exclusive-mob/mgc-new.htm"}, {
                        "title": "Money Wheel",
                        "url": "/exclusive-mob/money-wheel.htm"
                    }, {"title": "Netent 1500", "url": "/exclusive-mob/netent-1500.htm"}, {
                        "title": "Netent 1500 GNR Net",
                        "url": "/exclusive-mob/netent-1500-gnr-net.htm"
                    }, {
                        "title": "Netent 1500 GNR30",
                        "url": "/exclusive-mob/netent-1500-gnr30.htm"
                    }, {
                        "title": "Netent Exclusive",
                        "url": "/exclusive-mob/netent-exclusive.htm"
                    }, {
                        "title": "Netent Exclusive JohnSlots",
                        "url": "/exclusive-mob/netent-exclusive-JohnSlots.htm"
                    }, {
                        "title": "netent-1500-Xmas",
                        "url": "/exclusive-mob/netent-1500-Xmas.htm"
                    }, {
                        "title": "Netentcasino Exclusive",
                        "url": "/exclusive-mob/netentcasino-exclusive.htm"
                    }, {
                        "title": "Netentcasino10 Exclusive",
                        "url": "/exclusive-mob/netentcasino10-exclusive.htm"
                    }, {
                        "title": "New 88free Blackjack Row",
                        "url": "/exclusive-mob/new-88free-blackjack-row.htm"
                    }, {"title": "New Genie 88", "url": "/exclusive-mob/new-genie-88.htm"}, {
                        "title": "New Live Room",
                        "url": "/exclusive-mob/new-live-room.htm"
                    }, {
                        "title": "New Roulette 88",
                        "url": "/exclusive-mob/new-roulette-88.htm"
                    }, {
                        "title": "New Roulette 88",
                        "url": "/exclusive-mob/new-roulette-girl-88.htm"
                    }, {
                        "title": "New Roulette Girl 88 1500",
                        "url": "/exclusive-mob/new-roulette-girl-88-1500.htm"
                    }, {
                        "title": "new-roulette-girl-88-100",
                        "url": "/exclusive-mob/new-roulette-girl-88-100.htm"
                    }, {"title": "Offer 1500 88", "url": "/exclusive-mob/offer-1500-88.htm"}, {
                        "title": "Offer 1500 Canada",
                        "url": "/exclusive-mob/offer-1500-canada.htm"
                    }, {
                        "title": "Offer 1500 Canada Occ",
                        "url": "/exclusive-mob/offer-1500-canadafr.htm"
                    }, {
                        "title": "Offer 1500 Canada Occ",
                        "url": "/exclusive-mob/offer-1500-canada-occ.htm"
                    }, {
                        "title": "Offer 1500 Lithuania",
                        "url": "/exclusive-mob/offer-1500-lithuania.htm"
                    }, {
                        "title": "Offer 1500 NZ",
                        "url": "/exclusive-mob/offer-1500-nz.htm"
                    }, {
                        "title": "Offer 1500 RCasinos",
                        "url": "/exclusive-mob/offer-1500-RCasinos.htm"
                    }, {
                        "title": "Offer 200 Bonus Roullete",
                        "url": "/exclusive-mob/offer-200-bonus-roulette.htm"
                    }, {
                        "title": "offer-10free-canada",
                        "url": "/exclusive-mob/offer-10free-canada.htm"
                    }, {"title": "offer-1500", "url": "/exclusive-mob/offer-1500.htm"}, {
                        "title": "Paypal 200",
                        "url": "/exclusive-mob/paypal-200.htm"
                    }, {
                        "title": "Paypal 200 Casino24",
                        "url": "/exclusive-mob/paypal-200-casino24.htm"
                    }, {"title": "Paypal 200 New", "url": "/exclusive-mob/paypal-200-new.htm"}, {
                        "title": "Paypal New",
                        "url": "/exclusive-mob/paypal-new.htm"
                    }, {"title": "Paypal New Top Ten", "url": "/exclusive-mob/paypal-new-top-ten.htm"}, {
                        "title": "Pharaoh",
                        "url": "/exclusive-mob/pharaoh.htm"
                    }, {"title": "Pure Casino", "url": "/exclusive-mob/pure-casino.htm"}, {
                        "title": "Pure Casino Slots",
                        "url": "/exclusive-mob/pure-casino-slots.htm"
                    }, {
                        "title": "Pure Live Casino",
                        "url": "/exclusive-mob/pure-live-casino.htm"
                    }, {
                        "title": "RainbowRiches1500 888 Wheel",
                        "url": "/exclusive-mob/RainbowRiches1500-888-wheel.htm"
                    }, {
                        "title": "Real Rainbow Riched",
                        "url": "/exclusive-mob/real-rainbow-riched.htm"
                    }, {"title": "Recommended", "url": "/exclusive-mob/recommended.htm"}, {
                        "title": "Right",
                        "url": "/exclusive-mob/right.htm"
                    }, {"title": "Roulette 1500", "url": "/exclusive-mob/roulette-1500.htm"}, {
                        "title": "Roulette 50",
                        "url": "/exclusive-mob/roulette50.htm"
                    }, {
                        "title": "Roulette 88 1500",
                        "url": "/exclusive-mob/roulette-88-1500.htm"
                    }, {
                        "title": "Roulette1500 888 Wheel",
                        "url": "/exclusive-mob/Roulette1500-888-wheel.htm"
                    }, {
                        "title": "Roulette50 Norway",
                        "url": "/exclusive-mob/roulette50-norway.htm"
                    }, {
                        "title": "Roulette50 NZ",
                        "url": "/exclusive-mob/roulette50-nz.htm"
                    }, {
                        "title": "RouletteCA1500 888wheel",
                        "url": "/exclusive-mob/RouletteCA1500-888-wheel.htm"
                    }, {"title": "Selectbest", "url": "/exclusive-mob/selectbest.htm"}, {
                        "title": "Sfslotgame",
                        "url": "/exclusive-mob/sfslotgame.htm"
                    }, {"title": "Slot Collection", "url": "/exclusive-mob/slot-collection.htm"}, {
                        "title": "Slots 88 1500",
                        "url": "/exclusive-mob/slots-88-1500.htm"
                    }, {
                        "title": "Special 88 Valentines",
                        "url": "/exclusive-mob/special-88-valentines.htm"
                    }, {
                        "title": "Special Valentines",
                        "url": "/exclusive-mob/special-valentines.htm"
                    }, {"title": "Spelacasino", "url": "/exclusive-mob/spelacasino.htm"}, {
                        "title": "Spinata Grand",
                        "url": "/exclusive-mob/spinata-grand.htm"
                    }, {"title": "888casino", "url": "/exclusive-mob/starburst-hot.htm"}, {
                        "title": "Starburst New",
                        "url": "/exclusive-mob/starburst-new.htm"
                    }, {
                        "title": "Starburst New NLD",
                        "url": "/exclusive-mob/starburst-new-NLD.htm"
                    }, {
                        "title": "Starburst New NLD",
                        "url": "/exclusive-mob/starburst-new-NLD-intend.htm"
                    }, {
                        "title": "Starburst New NLD",
                        "url": "/exclusive-mob/starburst-new-nld-spot.htm"
                    }, {"title": "Starburst On", "url": "/exclusive-mob/starburst-on.htm"}, {
                        "title": "Swiss 1500",
                        "url": "/exclusive-mob/swiss-1500.htm"
                    }, {"title": "Swiss Italian 1500", "url": "/exclusive-mob/swiss-italian-1500.htm"}, {
                        "title": "test",
                        "url": "/exclusive-mob/test111.htm"
                    }, {"title": "Tiptop", "url": "/exclusive-mob/tiptop.htm"}, {
                        "title": "Top",
                        "url": "/exclusive-mob/top.htm"
                    }, {"title": "Top 5", "url": "/exclusive-mob/top-5.htm"}, {
                        "title": "Top 5 Best",
                        "url": "/exclusive-mob/top-5-best.htm"
                    }, {"title": "Top 5 Slots", "url": "/exclusive-mob/top-5-slots.htm"}, {
                        "title": "Top Rated",
                        "url": "/exclusive-mob/top-rated.htm"
                    }, {"title": "Top Ten", "url": "/exclusive-mob/top-ten.htm"}, {
                        "title": "Top UK Online Casinos",
                        "url": "/exclusive-mob/topukonlinecasinos.htm"
                    }, {"title": "Toptoday", "url": "/exclusive-mob/toptoday.htm"}, {
                        "title": "Treasure Fair",
                        "url": "/exclusive-mob/treasure-fair.htm"
                    }, {"title": "UK Casino", "url": "/exclusive-mob/uk-casino.htm"}, {
                        "title": "Welcome 140",
                        "url": "/exclusive-mob/welcome-140.htm"
                    }, {"title": "welcome200", "url": "/exclusive-mob/welcome200.htm"}, {
                        "title": "Wheel",
                        "url": "/exclusive-mob/wheel.htm"
                    }, {
                        "title": "Wheel 1500 Welcome",
                        "url": "/exclusive-mob/wheel-1500-welcome.htm"
                    }, {
                        "title": "Wheel 200 up to 400",
                        "url": "/exclusive-mob/wheel-200-up-to-400.htm"
                    }, {"title": "Wheel 200 upto 400", "url": "/exclusive-mob/wheel-200-upto-400.htm"}, {
                        "title": "Wheel",
                        "url": "/exclusive-mob/wheel-intend.htm"
                    }, {"title": "Wheel Vegasmaster Reg", "url": "/exclusive-mob/wheel-vegasmaster-reg.htm"}]
                }, {
                    "title": "Getting Started",
                    "url": "/getting-started/",
                    "children": [{"title": "Sign up", "url": "/getting-started/sign-up/"}, {
                        "title": "About Slot Races",
                        "url": "/getting-started/slot-races/"
                    }, {"title": "Mobile Buttons Legend", "url": "/getting-started/mobile-buttons/"}]
                }, {
                    "title": "Help",
                    "url": "/help/",
                    "children": [{"title": "Allow Flash", "url": "/help/allow-flash/"}]
                }, {"title": "Keno", "url": "/keno/"}, {
                    "title": "Live Casino",
                    "url": "/live-casino/",
                    "children": [{"title": "Dream Catcher", "url": "/live-casino/dream-catcher/"}, {
                        "title": "Elite Lounge",
                        "url": "/live-casino/elite-lounge/"
                    }, {"title": "Live 3 Card Poker", "url": "/live-casino/3-card-poker/"}, {
                        "title": "Live Baccarat",
                        "url": "/live-casino/baccarat/"
                    }, {"title": "Live Blackjack", "url": "/live-casino/blackjack/"}, {
                        "title": "Live Caribbean Stud Poker",
                        "url": "/live-casino/caribbean-stud/"
                    }, {"title": "Live Casino Hold'em", "url": "/live-casino/casino-holdem/"}, {
                        "title": "Live Roulette",
                        "url": "/live-casino/roulette/"
                    }, {"title": "Ultimate Texas Holdem", "url": "/live-casino/ultimate-texas-holdem/"}]
                }, {
                    "title": "Online Video Poker",
                    "url": "/video-poker/",
                    "children": [{
                        "title": "All American Double Up ",
                        "url": "/video-poker/all-american-double-up/"
                    }, {
                        "title": "Deuces Wild Double Up",
                        "url": "/video-poker/deuces-wild-double-up/"
                    }, {
                        "title": "Jacks or Better",
                        "url": "/video-poker/jacks-or-better/"
                    }, {"title": "Joker Wild Double Up ", "url": "/video-poker/joker-wild-double-up/"}]
                }, {
                    "title": "Online Casino Promotions",
                    "url": "/promotions/",
                    "children": [{
                        "title": "1st of The Month",
                        "url": "/promotions/1-month-bonus/"
                    }, {"title": "21st of The Month", "url": "/promotions/21-month-bonus/"}, {
                        "title": "Bonus Policy",
                        "url": "/promotions/bonus-policy/"
                    }, {"title": "Comp Points", "url": "/promotions/comp-points-bonus/"}, {
                        "title": "FreePlay Promotion",
                        "url": "/promotions/freeplay/"
                    }, {"title": "Friday Promotion", "url": "/promotions/friday-bonus/"}, {
                        "title": "How To Claim",
                        "url": "/promotions/how-to-claim/"
                    }, {"title": "888xtra", "url": "/promotions/live-casino-bonus/"}, {
                        "title": " Lucky 8 Promotion",
                        "url": "/promotions/live-casino-lucky-8-bonus/"
                    }, {
                        "title": "Vip Style Promotion",
                        "url": "/promotions/live-casino-vip-bonus/"
                    }, {"title": "Monday Promotion", "url": "/promotions/monday-bonus/"}, {
                        "title": "Saturday Promotion",
                        "url": "/promotions/saturday-bonus/"
                    }, {"title": "Sunday Promotion", "url": "/promotions/sunday-bonus/"}, {
                        "title": "Thursday Promotion",
                        "url": "/promotions/thursday-bonus/"
                    }, {"title": "Tuesday Promotion", "url": "/promotions/tuesday-bonus/"}, {
                        "title": "Wednesday Promotion",
                        "url": "/promotions/wednesday-bonus/"
                    }, {
                        "title": "Welcome Bonus Promotion",
                        "url": "/promotions/welcome-bonus-offer/"
                    }, {
                        "title": "Welcome Package",
                        "url": "/promotions/welcome-package/"
                    }, {
                        "title": "15-participation-bonus-tncs",
                        "url": "/promotions/15-participation-bonus-tncs/"
                    }, {"title": "88 No Deposit Bonus", "url": "/promotions/88-no-deposit-bonus/"}, {
                        "title": "888 Terms",
                        "url": "/promotions/888-terms/"
                    }, {
                        "title": "888casino-19-birthday",
                        "url": "/promotions/888casino-19-birthday/"
                    }, {
                        "title": "88freeplay-tncs",
                        "url": "/promotions/88freeplay-tncs/"
                    }, {
                        "title": "Cashback Voucher T&Cs",
                        "url": "/promotions/cashback-voucher-terms-conditions.htm"
                    }, {
                        "title": "conv-freeplay-freespins-terms-conditions",
                        "url": "/promotions/conv-freeplay-freespins-terms-conditions/"
                    }, {
                        "title": "coupon-terms-and-conditions-freeplay",
                        "url": "/promotions/coupon-terms-and-conditions-freeplay/"
                    }, {"title": "888casino", "url": "/promotions/daily-win-claim.htm"}, {
                        "title": "888casino",
                        "url": "/promotions/daily-win-spin.htm"
                    }, {
                        "title": "elite-prize-card-time",
                        "url": "/promotions/elite-prize-card-time/"
                    }, {
                        "title": "Flaming Freeplay Wheel",
                        "url": "/promotions/flaming-freeplay-wheel/"
                    }, {
                        "title": "Increasing Snowball",
                        "url": "/promotions/increasing-snowball/"
                    }, {
                        "title": "July Freeplay Boost Terms Conditions",
                        "url": "/promotions/july-freeplay-boost-terms-conditions/"
                    }, {
                        "title": "lucky-days",
                        "url": "/promotions/lucky-days-freeplay/"
                    }, {"title": "Monthly Loyalty Bonus", "url": "/promotions/monthly-loyalty-bonus/"}, {
                        "title": "my-test",
                        "url": "/promotions/my-test/"
                    }, {
                        "title": "new-players-only-freeplay",
                        "url": "/promotions/new-players-only-freeplay/"
                    }, {
                        "title": "new-sept-games-freeplay",
                        "url": "/promotions/new-sept-games-freeplay/"
                    }, {"title": "Pit Boss Terms", "url": "/promotions/pit-boss-terms/"}, {
                        "title": "Race Free Spins",
                        "url": "/promotions/race-free-spins/"
                    }, {
                        "title": "terms-and-conditions-bonus",
                        "url": "/promotions/terms-and-conditions-bonus/"
                    }, {
                        "title": "terms-and-conditions-freeplay",
                        "url": "/promotions/terms-and-conditions-freeplay/"
                    }, {
                        "title": "Winter is coming",
                        "url": "/promotions/winter-is-coming/"
                    }, {"title": "Winter Live Casino", "url": "/promotions/winter-live-casino-old/"}]
                }, {
                    "title": "Online Roulette",
                    "url": "/roulette/",
                    "children": [{"title": "3D Roulette", "url": "/roulette/3d/"}, {
                        "title": "American Roulette",
                        "url": "/roulette/american/"
                    }, {"title": "European Roulette", "url": "/roulette/european/"}, {
                        "title": "French Roulette",
                        "url": "/roulette/french/"
                    }, {"title": "Low Stakes Roulette", "url": "/roulette/low-stakes/"}]
                }, {
                    "title": "Security & Privacy",
                    "url": "/security-and-privacy/",
                    "children": [{
                        "title": "Privacy Policy",
                        "url": "/security-and-privacy/privacy-policy/"
                    }, {
                        "title": "Complete Security",
                        "url": "/security-and-privacy/complete-security/"
                    }, {"title": "Fair Play", "url": "/security-and-privacy/fair-play/"}, {
                        "title": "License",
                        "url": "/security-and-privacy/license/"
                    }, {
                        "title": "Responsible Gaming",
                        "url": "/security-and-privacy/responsible-gaming/"
                    }, {
                        "title": "Responsible Gaming Non-UK",
                        "url": "/security-and-privacy/responsible-gaming-nonuk/"
                    }, {
                        "title": "Responsible Gaming UK",
                        "url": "/security-and-privacy/responsible-gaming-uk/"
                    }, {
                        "title": "Third Party Cookies",
                        "url": "/security-and-privacy/third-party-cookies/"
                    }, {
                        "title": "User Agreement",
                        "url": "/security-and-privacy/user-agreement/"
                    }, {
                        "title": "User Agreement",
                        "url": "/security-and-privacy/user-agreement-nonuk/"
                    }, {
                        "title": "User Agreement",
                        "url": "/security-and-privacy/user-agreement-uk/"
                    }, {
                        "title": "Disconnection Policy ",
                        "url": "/security-and-privacy/disconnection-policy/"
                    }, {"title": "Spoofed Email", "url": "/security-and-privacy/spoofed-email/"}, {
                        "title": "No Spyware",
                        "url": "/security-and-privacy/no-spyware/"
                    }, {"title": "Legislation", "url": "/security-and-privacy/legislation/"}, {
                        "title": "888casino",
                        "url": "/security-and-privacy/vat-table-croatia/"
                    }, {"title": "888casino", "url": "/security-and-privacy/vat-table-germany/"}, {
                        "title": "888casino",
                        "url": "/security-and-privacy/vat-table-ireland/"
                    }, {"title": "888casino", "url": "/security-and-privacy/vat-table-other/"}, {
                        "title": "888casino",
                        "url": "/security-and-privacy/vat-table-Portugal/"
                    }]
                }, {"title": "Sitemap", "url": "/sitemap/"}, {
                    "title": "Slots",
                    "url": "/slots/",
                    "children": [{
                        "title": "A Nightmare on Elm Street Slot",
                        "url": "/slots/nightmare-on-elm-street/"
                    }, {
                        "title": "Adventures in Orbit Slot",
                        "url": "/slots/adventures-in-orbit/"
                    }, {"title": "blazing-star", "url": "/slots/blazing-star/"}, {
                        "title": "Casino Reels Slot",
                        "url": "/slots/casino-reels/"
                    }, {"title": "City Life Slot", "url": "/slots/city-life/"}, {
                        "title": "Clash of the Titans Slot",
                        "url": "/slots/clash-of-the-titans/"
                    }, {"title": "Cleopatra Slot", "url": "/slots/cleopatra/"}, {
                        "title": "Dawn of the Dinosaurs Slot",
                        "url": "/slots/dawn-of-the-dinosaurs/"
                    }, {"title": "Diamonds Delight", "url": "/slots/diamonds-delight/"}, {
                        "title": "Doctor Love Slot",
                        "url": "/slots/doctor-love/"
                    }, {
                        "title": "Double-Triple-Chance",
                        "url": "/slots/double-triple-chance/"
                    }, {"title": "dragons-treasure", "url": "/slots/dragons-treasure/"}, {
                        "title": "esqueleto-explosivo",
                        "url": "/slots/esqueleto-explosivo/"
                    }, {"title": "extra-wild", "url": "/slots/extra-wild/"}, {
                        "title": "Fairest of them All Slot",
                        "url": "/slots/fairest-of-them-all/"
                    }, {"title": "Fantastic Four Slot", "url": "/slots/fantastic-four/"}, {
                        "title": "Freaky Fruit",
                        "url": "/slots/freaky-fruit/"
                    }, {"title": "Fruit Shop Slot", "url": "/slots/fruit-shop/"}, {
                        "title": "Ghost in the Shell Slot",
                        "url": "/slots/ghost-in-the-shell/"
                    }, {"title": "Giant's Gold Slot", "url": "/slots/giants-gold/"}, {
                        "title": "Glorious 50 Slot",
                        "url": "/slots/the-glorious-50s/"
                    }, {"title": "Gods of Gold", "url": "/slots/gods-of-gold/"}, {
                        "title": "gold-cup",
                        "url": "/slots/gold-cup/"
                    }, {"title": "Gonzo's Quest Slot", "url": "/slots/gonzos-quest/"}, {
                        "title": "Irish Riches Slot",
                        "url": "/slots/irish-riches/"
                    }, {
                        "title": "Jack and the Beanstalk Slot",
                        "url": "/slots/jack-and-the-beanstalk/"
                    }, {"title": "Jackhammer Slot", "url": "/slots/jack-hammer/"}, {
                        "title": "Jacks Pot Slot",
                        "url": "/slots/jacks-pot/"
                    }, {"title": "Kiss Slot", "url": "/slots/kiss/"}, {
                        "title": "Leprechauns Luck Slot",
                        "url": "/slots/leprechauns-luck/"
                    }, {"title": "Millionaire Genie Slot", "url": "/slots/millionaire-genie/"}, {
                        "title": "multihand",
                        "url": "/slots/multihand/"
                    }, {
                        "title": "Oktoberfest Spins",
                        "url": "/slots/oktoberfest-spins/"
                    }, {"title": "Once Upon a Dime Slot", "url": "/slots/once-upon-a-dime/"}, {
                        "title": "Party Pigs Slot",
                        "url": "/slots/party-pigs/"
                    }, {"title": "Pirates Millions Slot", "url": "/slots/pirates-millions/"}, {
                        "title": "Raging Rhino Slot",
                        "url": "/slots/raging-rhino/"
                    }, {"title": "Rainbow Riches Slot", "url": "/slots/rainbow-riches/"}, {
                        "title": "Ramesses Riches Slot",
                        "url": "/slots/ramesses-riches/"
                    }, {"title": "Reel Rush Slot", "url": "/slots/reel-rush/"}, {
                        "title": "Rise Of The Pharaohs",
                        "url": "/slots/rise-of-the-pharaohs/"
                    }, {"title": "Ruby Slippers Slot", "url": "/slots/wizard-of-oz/"}, {
                        "title": "Santas Super Slot",
                        "url": "/slots/santas-super-slot/"
                    }, {"title": "Saved by the Bell Slot", "url": "/slots/saved-by-the-bells/"}, {
                        "title": "slot-races",
                        "url": "/slots/slot-races/"
                    }, {"title": "Snack Time Slot", "url": "/slots/snack-time/"}, {
                        "title": "South Park Slot",
                        "url": "/slots/south-park/"
                    }, {"title": "Spartacus Slot", "url": "/slots/spartacus/"}, {
                        "title": "Starburst Slot",
                        "url": "/slots/starburst/"
                    }, {
                        "title": "Steampunk Nation Slot",
                        "url": "/slots/steampunk-nation/"
                    }, {
                        "title": "The Big Lebowski Slot",
                        "url": "/slots/the-big-lebowski/"
                    }, {
                        "title": "Top Spin Snooker Slot",
                        "url": "/slots/top-spin-snooker/"
                    }, {"title": "Treasure Fair Slot", "url": "/slots/treasure-fair/"}, {
                        "title": "Twin Spin Slot",
                        "url": "/slots/twin-spin/"
                    }, {
                        "title": "Ultimate Grill Thrills Slot",
                        "url": "/slots/ultimate-grill-thrills/"
                    }, {
                        "title": "Ultimate Universe Slot",
                        "url": "/slots/ultimate-universe/"
                    }, {"title": "Under Construction", "url": "/slots/under-construction/"}, {
                        "title": "Victorious Slot",
                        "url": "/slots/victorious/"
                    }, {"title": "Video Test", "url": "/slots/vedio-test.htm"}, {
                        "title": "Wild Gambler Slot",
                        "url": "/slots/wild-gambler/"
                    }, {"title": "Zeus III Slot", "url": "/slots/zeus/"}]
                },
                {
                    "title": "Slots",
                    "url": "/slot-machine/",
                    "children": [{
                        "title": "A Nightmare on Elm Street Slot",
                        "url": "/slot-machine/nightmare-on-elm-street/"
                    }, {
                        "title": "Adventures in Orbit Slot",
                        "url": "/slot-machine/adventures-in-orbit/"
                    }, {"title": "blazing-star", "url": "/slot-machine/blazing-star/"}, {
                        "title": "Casino Reels Slot",
                        "url": "/slot-machine/casino-reels/"
                    }, {
                        "title": "City Life Slot",
                        "url": "/slot-machine/city-life/"
                    }, {
                        "title": "Clash of the Titans Slot",
                        "url": "/slot-machine/clash-of-the-titans/"
                    }, {
                        "title": "Cleopatra Slot",
                        "url": "/slot-machine/cleopatra/"
                    }, {
                        "title": "Dawn of the Dinosaurs Slot",
                        "url": "/slot-machine/dawn-of-the-dinosaurs/"
                    }, {
                        "title": "Diamonds Delight",
                        "url": "/slot-machine/diamonds-delight/"
                    }, {
                        "title": "Doctor Love Slot",
                        "url": "/slot-machine/doctor-love/"
                    }, {
                        "title": "Double-Triple-Chance",
                        "url": "/slot-machine/double-triple-chance/"
                    }, {
                        "title": "dragons-treasure",
                        "url": "/slot-machine/dragons-treasure/"
                    }, {
                        "title": "esqueleto-explosivo",
                        "url": "/slot-machine/esqueleto-explosivo/"
                    }, {
                        "title": "extra-wild",
                        "url": "/slot-machine/extra-wild/"
                    }, {
                        "title": "Fairest of them All Slot",
                        "url": "/slot-machine/fairest-of-them-all/"
                    }, {
                        "title": "Fantastic Four Slot",
                        "url": "/slot-machine/fantastic-four/"
                    }, {"title": "Freaky Fruit", "url": "/slot-machine/freaky-fruit/"}, {
                        "title": "Fruit Shop Slot",
                        "url": "/slot-machine/fruit-shop/"
                    }, {
                        "title": "Ghost in the Shell Slot",
                        "url": "/slot-machine/ghost-in-the-shell/"
                    }, {
                        "title": "Giant's Gold Slot",
                        "url": "/slot-machine/giants-gold/"
                    }, {
                        "title": "Glorious 50 Slot",
                        "url": "/slot-machine/the-glorious-50s/"
                    }, {"title": "Gods of Gold", "url": "/slot-machine/gods-of-gold/"}, {
                        "title": "gold-cup",
                        "url": "/slot-machine/gold-cup/"
                    }, {
                        "title": "Gonzo's Quest Slot",
                        "url": "/slot-machine/gonzos-quest/"
                    }, {
                        "title": "Irish Riches Slot",
                        "url": "/slot-machine/irish-riches/"
                    }, {
                        "title": "Jack and the Beanstalk Slot",
                        "url": "/slot-machine/jack-and-the-beanstalk/"
                    }, {"title": "Jackhammer Slot", "url": "/slot-machine/jack-hammer/"}, {
                        "title": "Jacks Pot Slot",
                        "url": "/slot-machine/jacks-pot/"
                    }, {"title": "Kiss Slot", "url": "/slot-machine/kiss/"}, {
                        "title": "Leprechauns Luck Slot",
                        "url": "/slot-machine/leprechauns-luck/"
                    }, {
                        "title": "Millionaire Genie Slot",
                        "url": "/slot-machine/millionaire-genie/"
                    }, {"title": "multihand", "url": "/slot-machine/multihand/"}, {
                        "title": "Oktoberfest Spins",
                        "url": "/slot-machine/oktoberfest-spins/"
                    }, {
                        "title": "Once Upon a Dime Slot",
                        "url": "/slot-machine/once-upon-a-dime/"
                    }, {
                        "title": "Party Pigs Slot",
                        "url": "/slot-machine/party-pigs/"
                    }, {
                        "title": "Pirates Millions Slot",
                        "url": "/slot-machine/pirates-millions/"
                    }, {
                        "title": "Raging Rhino Slot",
                        "url": "/slot-machine/raging-rhino/"
                    }, {
                        "title": "Rainbow Riches Slot",
                        "url": "/slot-machine/rainbow-riches/"
                    }, {
                        "title": "Ramesses Riches Slot",
                        "url": "/slot-machine/ramesses-riches/"
                    }, {"title": "Reel Rush Slot", "url": "/slot-machine/reel-rush/"}, {
                        "title": "Rise Of The Pharaohs",
                        "url": "/slot-machine/rise-of-the-pharaohs/"
                    }, {
                        "title": "Ruby Slippers Slot",
                        "url": "/slot-machine/wizard-of-oz/"
                    }, {
                        "title": "Santas Super Slot",
                        "url": "/slot-machine/santas-super-slot/"
                    }, {
                        "title": "Saved by the Bell Slot",
                        "url": "/slot-machine/saved-by-the-bells/"
                    }, {"title": "slot-races", "url": "/slot-machine/slot-races/"}, {
                        "title": "Snack Time Slot",
                        "url": "/slot-machine/snack-time/"
                    }, {"title": "South Park Slot", "url": "/slot-machine/south-park/"}, {
                        "title": "Spartacus Slot",
                        "url": "/slot-machine/spartacus/"
                    }, {
                        "title": "Starburst Slot",
                        "url": "/slot-machine/starburst/"
                    }, {
                        "title": "Steampunk Nation Slot",
                        "url": "/slot-machine/steampunk-nation/"
                    }, {
                        "title": "The Big Lebowski Slot",
                        "url": "/slot-machine/the-big-lebowski/"
                    }, {
                        "title": "Top Spin Snooker Slot",
                        "url": "/slot-machine/top-spin-snooker/"
                    }, {
                        "title": "Treasure Fair Slot",
                        "url": "/slot-machine/treasure-fair/"
                    }, {
                        "title": "Twin Spin Slot",
                        "url": "/slot-machine/twin-spin/"
                    }, {
                        "title": "Ultimate Grill Thrills Slot",
                        "url": "/slot-machine/ultimate-grill-thrills/"
                    }, {
                        "title": "Ultimate Universe Slot",
                        "url": "/slot-machine/ultimate-universe/"
                    }, {
                        "title": "Under Construction",
                        "url": "/slot-machine/under-construction/"
                    }, {"title": "Victorious Slot", "url": "/slot-machine/victorious/"}, {
                        "title": "Video Test",
                        "url": "/slot-machine/vedio-test.htm"
                    }, {"title": "Wild Gambler Slot", "url": "/slot-machine/wild-gambler/"}, {
                        "title": "Zeus III Slot",
                        "url": "/slot-machine/zeus/"
                    }]
                }, {
                    "title": "Slots",
                    "url": "/spillemaskiner/",
                    "children": [{
                        "title": "A Nightmare on Elm Street Slot",
                        "url": "/spillemaskiner/nightmare-on-elm-street/"
                    }, {
                        "title": "Adventures in Orbit Slot",
                        "url": "/spillemaskiner/adventures-in-orbit/"
                    }, {"title": "blazing-star", "url": "/spillemaskiner/blazing-star/"}, {
                        "title": "Casino Reels Slot",
                        "url": "/spillemaskiner/casino-reels/"
                    }, {
                        "title": "City Life Slot",
                        "url": "/spillemaskiner/city-life/"
                    }, {
                        "title": "Clash of the Titans Slot",
                        "url": "/spillemaskiner/clash-of-the-titans/"
                    }, {
                        "title": "Cleopatra Slot",
                        "url": "/spillemaskiner/cleopatra/"
                    }, {
                        "title": "Dawn of the Dinosaurs Slot",
                        "url": "/spillemaskiner/dawn-of-the-dinosaurs/"
                    }, {
                        "title": "Diamonds Delight",
                        "url": "/spillemaskiner/diamonds-delight/"
                    }, {
                        "title": "Doctor Love Slot",
                        "url": "/spillemaskiner/doctor-love/"
                    }, {
                        "title": "Double-Triple-Chance",
                        "url": "/spillemaskiner/double-triple-chance/"
                    }, {
                        "title": "dragons-treasure",
                        "url": "/spillemaskiner/dragons-treasure/"
                    }, {
                        "title": "esqueleto-explosivo",
                        "url": "/spillemaskiner/esqueleto-explosivo/"
                    }, {
                        "title": "extra-wild",
                        "url": "/spillemaskiner/extra-wild/"
                    }, {
                        "title": "Fairest of them All Slot",
                        "url": "/spillemaskiner/fairest-of-them-all/"
                    }, {
                        "title": "Fantastic Four Slot",
                        "url": "/spillemaskiner/fantastic-four/"
                    }, {"title": "Freaky Fruit", "url": "/spillemaskiner/freaky-fruit/"}, {
                        "title": "Fruit Shop Slot",
                        "url": "/spillemaskiner/fruit-shop/"
                    }, {
                        "title": "Ghost in the Shell Slot",
                        "url": "/spillemaskiner/ghost-in-the-shell/"
                    }, {
                        "title": "Giant's Gold Slot",
                        "url": "/spillemaskiner/giants-gold/"
                    }, {
                        "title": "Glorious 50 Slot",
                        "url": "/spillemaskiner/the-glorious-50s/"
                    }, {"title": "Gods of Gold", "url": "/spillemaskiner/gods-of-gold/"}, {
                        "title": "gold-cup",
                        "url": "/spillemaskiner/gold-cup/"
                    }, {
                        "title": "Gonzo's Quest Slot",
                        "url": "/spillemaskiner/gonzos-quest/"
                    }, {
                        "title": "Irish Riches Slot",
                        "url": "/spillemaskiner/irish-riches/"
                    }, {
                        "title": "Jack and the Beanstalk Slot",
                        "url": "/spillemaskiner/jack-and-the-beanstalk/"
                    }, {"title": "Jackhammer Slot", "url": "/spillemaskiner/jack-hammer/"}, {
                        "title": "Jacks Pot Slot",
                        "url": "/spillemaskiner/jacks-pot/"
                    }, {"title": "Kiss Slot", "url": "/spillemaskiner/kiss/"}, {
                        "title": "Leprechauns Luck Slot",
                        "url": "/spillemaskiner/leprechauns-luck/"
                    }, {
                        "title": "Millionaire Genie Slot",
                        "url": "/spillemaskiner/millionaire-genie/"
                    }, {"title": "multihand", "url": "/spillemaskiner/multihand/"}, {
                        "title": "Oktoberfest Spins",
                        "url": "/spillemaskiner/oktoberfest-spins/"
                    }, {
                        "title": "Once Upon a Dime Slot",
                        "url": "/spillemaskiner/once-upon-a-dime/"
                    }, {
                        "title": "Party Pigs Slot",
                        "url": "/spillemaskiner/party-pigs/"
                    }, {
                        "title": "Pirates Millions Slot",
                        "url": "/spillemaskiner/pirates-millions/"
                    }, {
                        "title": "Raging Rhino Slot",
                        "url": "/spillemaskiner/raging-rhino/"
                    }, {
                        "title": "Rainbow Riches Slot",
                        "url": "/spillemaskiner/rainbow-riches/"
                    }, {
                        "title": "Ramesses Riches Slot",
                        "url": "/spillemaskiner/ramesses-riches/"
                    }, {
                        "title": "Reel Rush Slot",
                        "url": "/spillemaskiner/reel-rush/"
                    }, {
                        "title": "Rise Of The Pharaohs",
                        "url": "/spillemaskiner/rise-of-the-pharaohs/"
                    }, {
                        "title": "Ruby Slippers Slot",
                        "url": "/spillemaskiner/wizard-of-oz/"
                    }, {
                        "title": "Santas Super Slot",
                        "url": "/spillemaskiner/santas-super-slot/"
                    }, {
                        "title": "Saved by the Bell Slot",
                        "url": "/spillemaskiner/saved-by-the-bells/"
                    }, {"title": "slot-races", "url": "/spillemaskiner/slot-races/"}, {
                        "title": "Snack Time Slot",
                        "url": "/spillemaskiner/snack-time/"
                    }, {"title": "South Park Slot", "url": "/spillemaskiner/south-park/"}, {
                        "title": "Spartacus Slot",
                        "url": "/spillemaskiner/spartacus/"
                    }, {
                        "title": "Starburst Slot",
                        "url": "/spillemaskiner/starburst/"
                    }, {
                        "title": "Steampunk Nation Slot",
                        "url": "/spillemaskiner/steampunk-nation/"
                    }, {
                        "title": "The Big Lebowski Slot",
                        "url": "/spillemaskiner/the-big-lebowski/"
                    }, {
                        "title": "Top Spin Snooker Slot",
                        "url": "/spillemaskiner/top-spin-snooker/"
                    }, {
                        "title": "Treasure Fair Slot",
                        "url": "/spillemaskiner/treasure-fair/"
                    }, {
                        "title": "Twin Spin Slot",
                        "url": "/spillemaskiner/twin-spin/"
                    }, {
                        "title": "Ultimate Grill Thrills Slot",
                        "url": "/spillemaskiner/ultimate-grill-thrills/"
                    }, {
                        "title": "Ultimate Universe Slot",
                        "url": "/spillemaskiner/ultimate-universe/"
                    }, {
                        "title": "Under Construction",
                        "url": "/spillemaskiner/under-construction/"
                    }, {"title": "Victorious Slot", "url": "/spillemaskiner/victorious/"}, {
                        "title": "Video Test",
                        "url": "/spillemaskiner/vedio-test.htm"
                    }, {
                        "title": "Wild Gambler Slot",
                        "url": "/spillemaskiner/wild-gambler/"
                    }, {"title": "Zeus III Slot", "url": "/spillemaskiner/zeus/"}]
                }, {
                    "title": "Page Templates",
                    "url": "/templates/",
                    "children": [{"title": "Slots", "url": "/templates/manual-lobby.htm"}, {
                        "title": "Manual",
                        "url": "/templates/manual.htm"
                    }, {"title": "Slots", "url": "/templates/blackjack-lobby.htm"}, {
                        "title": "Slots",
                        "url": "/templates/Live-Casino-lobby.htm"
                    }, {"title": "Casino Games", "url": "/templates/Game-Template.htm"}, {
                        "title": "Casino Games",
                        "url": "/templates/LiveCasino-Inner-Page-Template.htm"
                    }, {"title": "Slots", "url": "/templates/promotion-lobby.htm"}, {
                        "title": "Promotions",
                        "url": "/templates/promotion-page.htm"
                    }, {"title": "Promotions", "url": "/templates/promotion-page-bg.htm"}, {
                        "title": "Promotions",
                        "url": "/templates/promotion-page-bg-protocol.htm"
                    }]
                }, {
                    "title": "dinero",
                    "url": "/dinero-real/",
                    "children": [
                        {"title": "dinero pagos", "url": "/dinero-real/pagos/"},
                        {"title": "dinero cobros", "url": "/dinero-real/cobros/"}
                    ]
                }, {
                    "title": "como-empezar",
                    "url": "/como-empezar/",
                    "children": [
                        {"title": "verificar ahora", "url": "/como-empezar/verificar-ahora/"}
                    ]
                }, {
                    "title": "Casino Tools",
                    "url": "/tools/",
                    "children": [{"title": "888casino", "url": "/tools/buttons.htm"}, {
                        "title": "888casino",
                        "url": "/tools/buttons-inner-page.htm"
                    }, {"title": "888casino", "url": "/tools/buttons-landing-page.htm"}, {
                        "title": "888casino",
                        "url": "/tools/eyal-test.htm"
                    }, {"title": "888casino", "url": "/tools/eyal-webpage-1.htm"}, {
                        "title": "888casino",
                        "url": "/tools/eyal-webpage-2.htm"
                    }, {"title": "888casino", "url": "/tools/parameters-test.htm"}, {
                        "title": "888casino",
                        "url": "/tools/set-cookie.htm"
                    }, {"title": "888casino", "url": "/tools/temp-test.htm"}, {
                        "title": "888casino",
                        "url": "/tools/test-test.htm"
                    }, {"title": "888casino", "url": "/tools/test-test2.htm"}]
                }, {"title": "VIP", "url": "/vip/"}]
        },
    };

    window['sCut'] = Object.create({
        data: {
            "lang": params.languageIso2,
            "sr": 486415,
            "testdata": "{\"referrer\":\"NULL\",\"orig-lp\":\"https://mirage-888poker.images4us.com/en/abc_pages/abc_scut_cwc_tbbs/abc_scut_cwc_tbbs.htm\"}",
            "isftd": "false",
            "country": params.country,
            "campaignid": "24270",
            "iswin": "1",
            "landingpage": "https://mirage-888poker.images4us.com/en/abc_pages/abc_scut_cwc_tbbs/abc_scut_cwc_tbbs.htm",
            "referrer": "NULL",
            "orig-lp": "https://mirage-888poker.images4us.com/en/abc_pages/abc_scut_cwc_tbbs/abc_scut_cwc_tbbs.htm"
        },
        all: function () {
            return this.data;
        },
        toString: function () {
            return "lang=en&sr=486413&testdata=%7B%22referrer%22:%22http://localhost:7070/index.html%22,%22last-referrer%22:%22http://localhost:7070/index.html%22,%22orig-lp%22:%22https://stage-new-www.888casino.com/app/races.htm%22%7D&referrer=http://localhost:8080/index.html&country=isr&campaignid=24270&landingpage=https://stage-new-www.888casino.com/app/races.htm&iswin=0&isftd=false&orig-lp=https://stage-new-www.888casino.com/app/races.htm&wtc=UA-12287920-5__11517766278042"
        }
    });
}

function loadLauncherOverridesFromUrl() {
    try {
        const clientDataParam = 'clientData=';
        let clientDataIndex = window.location.hash.indexOf( clientDataParam);

        if(clientDataIndex === -1) {
            return;
        }

        let clientDataSTR = window.location.hash.substring(clientDataIndex + clientDataParam.length);
        let clientData = JSON.parse(decodeURIComponent(clientDataSTR));
        let cgpClient = {
            clientData: clientData
        };

        localStorage.setItem('cgp_client', JSON.stringify(cgpClient));
        window.history.replaceState("", document.title, window.location.pathname + window.location.search);
    } catch (err) {
        console.error('Failed to load launcher overrides from URL', err);
    }

}

export async function startOrbit(): Promise<void> {

    loadLauncherOverridesFromUrl();

    let launcherOverrides = getLauncherOverrides();

    let sdkApiHost = launcherOverrides?.sdk?.api || window.location.origin;

    let cmsSource = launcherOverrides?.orbit?.cmsSource;
    let publicationId = launcherOverrides?.orbit?.publicationID;
    let languageIso3 = launcherOverrides?.orbit?.language || 'eng';
    let languageIso2 = launcherOverrides?.orbit?.iso2 || 'en';
    let country = launcherOverrides?.orbit?.country || 'isr';
    let domain = tryGetHostnameFromURL(cmsSource) || window.location.hostname;
    let userIP = launcherOverrides?.sdk?.OAuth2?.fakeClientIP || '127.0.0.1';
    let brandId = launcherOverrides?.sdk?.Skin?.brandID || '';
    let subBrandId = launcherOverrides?.sdk?.Skin?.subBrandID || '';
    let regulationId = launcherOverrides?.sdk?.Skin?.regulationID || '';

    await createB2CData({
        country: country,
        cmsSource: cmsSource,
        languageIso2: languageIso2,
        languageIso3: languageIso3,
        publicationId: publicationId
    });

    // TODO - switch to /cgpapi/orbit/config/mixed
    let url = `${sdkApiHost}/orbit/config/mixed?domain=${domain}&language=${languageIso3}&country=${country}&userIP=${userIP}&brandId=${brandId}&subBrandId=${subBrandId}&regulationId=${regulationId}&allowUnfilteredGames=true&rand=${Math.random()}`;

    let response = await httpService.get(url);

    let el = processScriptsFromHTML(response.body);
    let elContent = Array.prototype.slice.call(el.children);
    for (let i = 0; i < elContent.length; i++) {
        document.body.appendChild(elContent[i]);
    }

    //always run service worker starter in QA/local env
    if (Check.isFunction(window['orbitServiceWorkerStarter'])) {
        window['orbitServiceWorkerStarter']();
    }

    setTimeout(addMirageBannersContainer, 3000);
}
